import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SSOService } from '../../services/sso.service';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './support.html',
  styleUrl: './support.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportComponent {
  isLoggedIn: boolean;

  constructor(private ssoService: SSOService) {
    this.isLoggedIn = this.ssoService.isAuthenticated();
  }
}
